import { render } from "./QuestionsSimulado.vue?vue&type=template&id=2997fe07&scoped=true"
import script from "./QuestionsSimulado.vue?vue&type=script&lang=js"
export * from "./QuestionsSimulado.vue?vue&type=script&lang=js"

import "./QuestionsSimulado.vue?vue&type=style&index=0&id=2997fe07&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2997fe07"]])

export default __exports__